<!-- Phase 3 create-modal template: BUI-styled form content hosted inside the
     shared Dialog.vue wrapper (see PlaylistsListView.vue). Other create
     modals should follow this pattern. -->

<template>
  <div class="create-playlist-form">
    <StatusBar
      :errorMessage="errorMessage"
      :isLoading="isLoading"
      loadingMessage="Saving..."
      :isSuccess="isSuccess"
      successMessage="Saved!"
    />
    <div class="field-content">
      <!-- TODO: think about adding below-field error message & error state indication (e.g. red border) [DSP-N26CxI4P] -->
      <div class="d-flex field-row">
        <label for="cpf-name" class="basis-1/2 text-sm font-bold">Name &#9733;</label>
        <TextField
          id="cpf-name"
          name="name"
          v-model="values.name"
          class="basis-1/2"
          width="100%"
        />
      </div>
      <div class="d-flex field-row">
        <label for="cpf-duration" class="basis-1/2 text-sm font-bold">Default Duration &#9733;</label>
        <NumberField
          id="cpf-duration"
          name="defaultDuration"
          v-model="values.defaultItemDuration"
          class="basis-1/2"
          width="100%"
        />
      </div>
    </div>
    <div class="form-buttons">
      <ButtonCustomized label="Cancel" @click="onCancel" ctaSecondary />
      <ButtonCustomized label="Create" cta @click="onSubmit" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import NumberField from "@/components/form-fields/NumberField.vue";
import TextField from "@/components/form-fields/TextField.vue";
import ButtonCustomized from "@/components/form-fields/ButtonCustomized.vue";
import StatusBar from "@/components/form-fields/StatusBar/StatusBar.vue";

import useCreatePlaylistFormHelpers from "./composables/createPlaylistFormHelpers";
import useNotifications from "@/components/Notifications/composables/notifications";

import router from '@/router';


const emit = defineEmits(['submit', 'cancel', 'success', 'fail'])

const notification = useNotifications();

const { values, submitForm, isLoading, isSuccess, errorMessage, newPlaylistId } = useCreatePlaylistFormHelpers();

async function onSubmit() {
  await submitForm();
  if(isSuccess.value === true) {
    notification.success('Playlist created successfully!');
    emit('success');
    router.push({name: 'playlist-editor', params: {id: newPlaylistId.value}});
  } else {    // on failure
    emit('fail');
  }
}

function onCancel() {
  emit('cancel');
}
</script>

<style lang="scss" scoped>
.create-playlist-form {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: min(26rem, calc(100vw - 6rem));
  color: var(--bui-tbl-row-text, #2a2969);
}

.field-content {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;

  /* Token-colour the legacy form atoms (same overrides as the editor template). */
  :deep(.field label) {
    color: var(--bui-tbl-row-text, #2a2a30);
  }

  :deep(.field input[type='text']),
  :deep(.field input[type='number']),
  :deep(.field textarea) {
    color: var(--bui-ter-input-text, #1a1a1e);
    background: var(--bui-ter-input-fill, rgba(0, 0, 0, 0.04));
    border-color: var(--bui-ter-input-border, rgba(0, 0, 0, 0.12));
  }
}

.field-row {
  align-items: center;

  label {
    color: var(--bui-tbl-row-text, #2a2a30);
  }
}

.form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
}
</style>
